import register from '@wcd/preact-custom-element';

export const component = ({ children, 'review-id': reviewId, 'author-id': authorId}) => {

  let replyContent = '';

  const show = (element) =>  element?.style?.setProperty('display', 'block');
  const hide = (element) =>  element?.style?.setProperty('display', 'none');
  const onInput = (event) => { replyContent = (event.target as HTMLTextAreaElement).value; }

  const repliesContainer = document.getElementById(`review-${reviewId}-replies__container`);
  const showRepliesButton = document.getElementById(`review-${reviewId}-show-replies__cta`);
  const hideRepliesButton = document.getElementById(`review-${reviewId}-hide-replies__cta`);
  const cancelReplyButton = document.getElementById(`review-${reviewId}-reply--cancel__cta`);
  const submitReplyButton = document.getElementById(`review-${reviewId}-reply-submit__cta`);
  const writeReplyTextarea = document.getElementById(`review-${reviewId}-reply-write__body`);
  const writeReplyBock = document.getElementById(`review-${reviewId}-reply-write__section`);
  const reviewsGeneralError = document.getElementById('reviews-general-error');

  const showReplies = () => {
    hide(showRepliesButton);
    show(repliesContainer);
    show(hideRepliesButton);
  };

  const hideReplies = () => {
    show(showRepliesButton);
    hide(repliesContainer);
    hide(hideRepliesButton);
  };

  const hideWriteReply = () => {
    hide(writeReplyBock);
  };

  const validateReply = () => {
    writeReplyBock?.classList.remove('review-reply-write__block--has-error');
    let validates = true;

    if (replyContent.length === 0) {
      validates = false;
      writeReplyBock?.classList.add('review-reply-write__block--has-error');
    }

    return validates;
  }

  const postReply = async () => {

    if (!validateReply()) {
      return;
    }

    const reply = {
      review: {
        id: reviewId,
        authorId
      },
      comment: replyContent,
    };

    const response = await fetch(`/api/review/reply/`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(reply),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const { error } = await response.json();
      reviewsGeneralError?.lastChild?.replaceWith(error);
      show(reviewsGeneralError)
    } else {
      hideWriteReply();
      hide(reviewsGeneralError);
    }
  };

  showRepliesButton?.addEventListener('click', showReplies);
  hideRepliesButton?.addEventListener('click', hideReplies);
  cancelReplyButton?.addEventListener('click', hideWriteReply);
  writeReplyTextarea?.addEventListener('input', onInput);
  submitReplyButton?.addEventListener('click', postReply);

  return children;
};

register(component, 'review-item', [], { shadow: false });

